module.exports = require('./lib/jwt');



//////////////////
// WEBPACK FOOTER
// ../~/jwt-simple/index.js
// module id = 129
// module chunks = 0